import React from 'react';
import './PageHeaderDescription.less';

export const PageHeaderDescription = ({text}) => {
	return <span className="page-header-description">{text}</span>
}
